export default __webpack_public_path__ + "static/media/icon-key.3448d6cb.svg";